(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  var nav = document.querySelector('.sleepys-mega-nav');
  if (!nav) return;

  var menus = nav.querySelectorAll('.sleepys-mega-menu');
  if (!menus.length) return;

  function positionPointer(details) {
    if (!mq.matches || !details.open) return;
    var panel = details.querySelector('.sleepys-mega-menu__panel');
    var summary = details.querySelector('.sleepys-mega-menu__summary');
    if (!panel || !summary) return;
    var sr = summary.getBoundingClientRect();
    var pr = panel.getBoundingClientRect();
    var x = sr.left + sr.width / 2 - pr.left;
    panel.style.setProperty('--sleepys-mega-pointer-x', Math.round(x) + 'px');
  }

  function clearPointer(details) {
    var panel = details.querySelector('.sleepys-mega-menu__panel');
    if (panel) panel.style.removeProperty('--sleepys-mega-pointer-x');
  }

  function refreshOpen() {
    menus.forEach(function (d) {
      if (d.open) positionPointer(d);
    });
  }

  menus.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        requestAnimationFrame(function () {
          positionPointer(details);
        });
      } else {
        clearPointer(details);
      }
    });
  });

  window.addEventListener('resize', refreshOpen, { passive: true });

  var sticky = document.querySelector('sticky-header');
  if (sticky && typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(refreshOpen);
    ro.observe(sticky);
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', refreshOpen);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(refreshOpen);
  }
})();
